import type { FC } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SystemTutorial } from "../../components/UIToolkit/Dialogs/SystemTutorial";
import type { TutorialStep } from "../../utils/models";

type SelfSchedulingTutorialProps = { open: boolean; onClose: () => void; shiftsPerWeekByEmploymentType: number };

export const SelfSchedulingTutorial: FC<SelfSchedulingTutorialProps> = ({ open, onClose, shiftsPerWeekByEmploymentType }) => {
	const { t } = useTranslation();
	const steps = useMemo<TutorialStep[]>(
		() => [
			{
				title: t("self.scheduling.tutorial.step1.title"),
				body: t("self.scheduling.tutorial.step1.body"),
				image: "self-scheduling-assign.png",
			},
			{
				title: t("self.scheduling.tutorial.step2.title"),
				body: t("self.scheduling.tutorial.step2.body"),
				image: "self-scheduling-submit.png",
			},
			{
				title: t("Attention!"),
				body: t("self.scheduling.attention", { count: shiftsPerWeekByEmploymentType }),
			},
		],
		[t, shiftsPerWeekByEmploymentType],
	);

	return <SystemTutorial open={open} onClose={onClose} steps={steps} tutorialKey="self-scheduling" />;
};
